if (!customElements.get('quote-item')) {
  class QuoteItem extends HTMLElement {
    constructor() {
      super();

      // options
      this.options = {
        id: parseInt(parseJson(this.dataset.options).id),
        variantId: parseInt(parseJson(this.dataset.options).variantId) || null,
        fakeVariant:
          parseJson(this.dataset.options).fakeVariant === 'null'
            ? null
            : parseJson(this.dataset.options).fakeVariant,
        audiogram: parseJson(this.dataset.options).audiogram === 'true' ? true : false,
      };

      // elements
      this.quotePage = this.closest('quote-page');
      this.quantityInput = this.querySelector('quote-quantity-input input');
      this.quantityButtons = this.querySelectorAll('button');
      this.quantityRemove = this.querySelector('quote-remove-button');
      this.fakeVariant = this.querySelector('[data-quote-product-fake-variant]');

      // event listeners
      this.quantityInput.addEventListener('change', this.updateQuantity.bind(this));
      this.quantityButtons.forEach((button) => {
        button.addEventListener('click', this.updateQuantity.bind(this));
      });
      this.quantityRemove.addEventListener('click', this.removeQuoteItem.bind(this));

      // join/create the quote broadcast channel
      this.quoteChannel = new BroadcastChannel('quote-channel');

      // init the quote item
      this.initQuoteItem();
    }

    /**
     * Initialize the quote item when it is added to the DOM
     */
    initQuoteItem() {
      const quoteItems = parseJson(localStorage.getItem('quote_cart'));
      const quoteItem = quoteItems.find(
        (quoteItem) =>
          quoteItem.product.id === this.options.id &&
          quoteItem.variantId === this.options.variantId &&
          quoteItem.fakeVariant === this.options.fakeVariant
      );

      const quantity = quoteItem.quantity;
      const fakeVariant = quoteItem.fakeVariant;

      if (fakeVariant) {
        this.fakeVariant.classList.remove('hidden');
        this.fakeVariant.querySelector('dd').textContent = fakeVariant;
      }

      this.quantityInput.value = quantity;

      // disable the remove button if the quantity is 1
      if (quantity === 1) {
        this.querySelector('button[name="minus"]').setAttribute('disabled', '');
      }
    }

    /**
     * Update the quantity of the quote item
     */
    updateQuantity(event) {
      const buttonType = event.target.name;

      let quoteItems = parseJson(localStorage.getItem('quote_cart'));
      const quoteItem = quoteItems.find(
        (quoteItem) =>
          quoteItem.product.id === this.options.id &&
          quoteItem.variantId === this.options.variantId &&
          quoteItem.fakeVariant === this.options.fakeVariant
      );

      let newQuoteItem = quoteItem;

      if (buttonType === 'minus') {
        if (newQuoteItem.quantity === 1) {
          return;
        }
        newQuoteItem.quantity--;
      } else if (buttonType === 'plus') {
        newQuoteItem.quantity++;
      } else {
        if (parseInt(event.target.value) < 1) {
          newQuoteItem.quantity = 1;
        } else {
          newQuoteItem.quantity = parseInt(this.quantityInput.value);
        }
      }

      // remove the quote item from the quote cart
      quoteItems.splice(quoteItems.indexOf(quoteItem), 1);

      // add the updated quote item to the quote cart
      quoteItems.push(newQuoteItem);

      // update the quantity input
      this.quantityInput.value = newQuoteItem.quantity;

      // disable the remove button if the quantity is 1
      if (newQuoteItem.quantity === 1) {
        this.querySelector('button[name="minus"]').setAttribute('disabled', '');
      } else {
        this.querySelector('button[name="minus"]').removeAttribute('disabled');
      }

      // update the quote cart in local storage
      localStorage.setItem('quote_cart', JSON.stringify(quoteItems));

      // dispatch the quote-added event, so the quote-icon-bubble can update
      this.quoteChannel.postMessage('quote-added');

      // update the subtotal
      this.quotePage.updateSubtotal();
    }

    /**
     * Remove the quote item from the quote cart
     */
    removeQuoteItem(checkAudiogram = true, updateSubtotal = true) {
      let quoteItems = parseJson(localStorage.getItem('quote_cart'));
      const quoteItem = quoteItems.find(
        (quoteItem) =>
          quoteItem.product.id === this.options.id &&
          quoteItem.variantId === this.options.variantId &&
          quoteItem.fakeVariant === this.options.fakeVariant
      );

      // remove the quote item from the quote cart
      quoteItems.splice(quoteItems.indexOf(quoteItem), 1);

      // update the quote cart in local storage
      localStorage.setItem('quote_cart', JSON.stringify(quoteItems));

      if (quoteItems.length === 0) {
        this.quotePage.classList.add('quote-cart-is-empty');
      }
      // remove the quote item from the DOM
      this.remove();

      // dispatch the quote-added event, so the quote-icon-bubble can update
      this.quoteChannel.postMessage('quote-added');

      // check audiogram
      if (checkAudiogram) {
        this.quotePage.audiogramForm?.checkAudiogram();
      }

      // update the subtotal
      if (updateSubtotal) {
        this.quotePage.updateSubtotal();
      }
    }
  }

  window.QuoteItem = QuoteItem;
  customElements.define('quote-item', QuoteItem);
}
